import MasterItemSubcontApi from './RegItemSubkonApi';

export default MasterItemSubcontApi;
